var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5684 5.47657H8.47693C6.02069 5.47657 4.03125 7.56549 4.03125 10.1445C4.03125 12.7236 6.02069 14.8125 8.47693 14.8125H19.5911C20.8137 14.8125 21.814 15.8628 21.814 17.1465C21.814 18.4302 20.8137 19.4805 19.5911 19.4805H10.4997C10.0329 18.1268 8.81036 17.1465 7.36551 17.1465C5.52055 17.1465 4.03125 18.7103 4.03125 20.6475C4.03125 22.5847 5.52055 24.1484 7.36551 24.1484C8.81036 24.1484 10.0329 23.1682 10.4997 21.8145H19.5911C22.0474 21.8145 24.0368 19.7255 24.0368 17.1465C24.0368 14.5674 22.0474 12.4785 19.5911 12.4785H8.47693C7.25437 12.4785 6.25409 11.4282 6.25409 10.1445C6.25409 8.86085 7.25437 7.81056 8.47693 7.81056H17.5684C17.8306 8.58773 18.346 9.2426 19.0235 9.65947C19.701 10.0763 20.497 10.2284 21.2709 10.0888C22.0448 9.94915 22.7468 9.52683 23.2529 8.89642C23.759 8.26601 24.0367 7.46808 24.0368 6.64356C24.0368 4.70636 22.5475 3.14259 20.7026 3.14259C19.2577 3.14259 18.0351 4.12286 17.5684 5.47657Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRideIcon);
export default __webpack_public_path__ + "static/media/ride-icon.5620c3c2d789e2de6f4397273aacfeaf.svg";
export { ForwardRef as ReactComponent };